import { createContext, useContext } from 'react';

interface LinkDialogContextValue {
  openLinkDialog: () => void;
}

const LinkDialogContext = createContext<LinkDialogContextValue | null>(null);

export const LinkDialogProvider = LinkDialogContext.Provider;

export const useLinkDialog = () => {
  const ctx = useContext(LinkDialogContext);

  if (!ctx) throw new Error('useLinkDialog must be used within LinkDialogProvider');

  return ctx;
};
